export function getCategoryLabel(category: string, labelByKey?: Record<string, string>) {
  if (labelByKey) {
    const found = labelByKey[category];
    if (found) return found;
  }
  switch (category.toLowerCase()) {
    case "direct":
      return "Direct EB-5";
    case "regional_center":
      return "Regional Center";
    default:
      return toTitleCase(category);
  }
}

export function getInvestmentTypeLabel(type: string) {
  switch (type.toLowerCase()) {
    case "rural":
      return "Rural TEA";
    case "urban":
      return "Urban TEA";
    case "infrastructure":
      return "Infrastructure";
    default:
      return type;
  }
}

/**
 * Short TEA classification for the "Classification" fact ("Rural", "Urban",
 * "Infrastructure"). Returns null for blank / unknown values so callers can
 * render an empty state instead of guessing.
 */
export function getClassificationLabel(type: string | null | undefined): string | null {
  const t = type?.trim().toLowerCase();
  if (!t) return null;
  switch (t) {
    case "rural":
      return "Rural";
    case "urban":
      return "Urban";
    case "infrastructure":
      return "Infrastructure";
    case "non_tea":
    case "non-tea":
    case "none":
      return "Non-TEA";
    default:
      return toTitleCase(t);
  }
}

export function isTEA(type: string) {
  const t = type.toLowerCase();
  return t === "rural" || t === "urban" || t === "infrastructure";
}

export function isApproved(i956fApprovedAt: string | null | undefined): boolean {
  return !!i956fApprovedAt;
}

function toTitleCase(s: string) {
  return s
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatStructureLabel(s: string | null | undefined): string {
  if (!s) return "N/A";
  const map: Record<string, string> = {
    senior_debt: "Senior Debt",
    senior_secured_debt: "Senior Secured Debt",
    mezzanine: "Mezzanine",
    mezzanine_debt: "Mezzanine Debt",
    subordinate_debt: "Subordinate Debt",
    equity: "Equity",
    preferred_equity: "Preferred Equity",
    jcf: "Job Creation Fund",
    regional_center: "Regional Center",
    direct: "Direct",
  };
  return map[s.toLowerCase()] ?? toTitleCase(s);
}

export function formatPositionLabel(s: string | null | undefined): string {
  if (!s) return "N/A";
  const map: Record<string, string> = {
    senior: "Senior",
    mezzanine: "Mezzanine",
    equity: "Equity",
    first_lien: "1st Lien",
    second_lien: "2nd Lien",
    preferred: "Preferred",
    subordinate: "Subordinate",
  };
  return map[s.toLowerCase()] ?? toTitleCase(s);
}
